export default class HutanActions {
  static NEW_DATA = "NEW_DATA";
  static UPDATE_DATA = "UPDATE_DATA";
  static SHOW_DATA = "SHOW_DATA";
  static VIEW_DATA = "VIEW_DATA";
  static DELETE_DATA = "DELETE_DATA";
  static ON_SUBMIT = "ON_SUBMIT";
  static ERROR_DATA = "ERROR_DATA";
  static PROCESS_DATA = "PROCESS_DATA";
  static RESET_DATA = "RESET_DATA";
  static SUCCESS_DATA = "SUCCESS_DATA";
  static ERROR_SERVER = "ERROR_SERVER";
  //static GET_HELPER_AccSetup ='GET_HELPER_AccSetup';
  static submit() {
    return {
      type: HutanActions.ON_SUBMIT,
    };
  }

  static create(data) {
    return {
      type: HutanActions.NEW_DATA,
      payload: data,
    };
  }

  static update(data) {
    return {
      type: HutanActions.UPDATE_DATA,
      payload: data,
    };
  }

  static view(data) {
    return {
      type: HutanActions.VIEW_DATA,
      payload: data,
    };
  }

  static delete(data) {
    return {
      type: HutanActions.DELETE_DATA,
    };
  }

  static list(data) {
    return {
      type: HutanActions.SHOW_DATA,
      payload: data,
    };
  }
  static error(error) {
    return {
      type: HutanActions.ERROR_DATA,
      payload: error,
    };
  }
  static success() {
    return {
      type: HutanActions.SUCCESS_DATA,
    };
  }
  static process() {
    return {
      type: HutanActions.PROCESS_DATA,
    };
  }
  static reset() {
    return {
      type: HutanActions.RESET_DATA,
    };
  }
  //   static getHelper(data){
  //     return{
  //       type : HutanActions.GET_HELPER_AccSetup,
  //       payload : data
  //     };

  //   }
  static errorInternal(error) {
    return {
      type: HutanActions.ERROR_SERVER,
      payload: error,
    };
  }
}
